import { Error, Warning, Pending } from '@mui/icons-material';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import styles from './StatusCell.module.scss';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

const StatusCell = ({ row, value }: GridRenderCellParams) => {
    if (value === 'processing') {
        return (
            <div className={styles.wrapper}>
                <Pending
                    className={classnames(styles.icon, styles.loadingIcon)}
                />
                Analyzing contract
            </div>
        );
    }

    if (value === 'failed') {
        return (
            <div className={styles.wrapper}>
                <Error className={classnames(styles.icon, styles.errorIcon)} />
                Analysis failed
            </div>
        );
    }

    if (value === 'awaiting_user_action') {
        return (
            <div className={styles.wrapper}>
                <Warning
                    className={classnames(styles.icon, styles.warningIcon)}
                />
                Please
                <Link
                    to={`/stream/${row.deal_type}/contract/${row.contract_uuid}/parties`}
                >
                    set the parties
                </Link>
            </div>
        );
    }

    //TOOD: remove the '-' once contrct data is fixed
    return value || '-';
};

export default StatusCell;
